import { render, staticRenderFns } from "./MedicineAnalogsList.vue?vue&type=template&id=378c32de&scoped=true"
import script from "./MedicineAnalogsList.vue?vue&type=script&lang=js"
export * from "./MedicineAnalogsList.vue?vue&type=script&lang=js"
import style0 from "./MedicineAnalogsList.vue?vue&type=style&index=0&id=378c32de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378c32de",
  null
  
)

export default component.exports